import { FC, memo } from "react";
import { IFormItemProps } from "./formItem.props";
import { AntdFormItem } from "./formItem.style";

const FormItem: FC<IFormItemProps> = ({ ...props }) => {
  return <AntdFormItem {...props} />;
};

export default memo(FormItem);
